import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DialogForm from '@/components/DialogForm.vue';
    import { Button } from '@/components/ui/button';
    import { useForm } from '@inertiajs/vue3';
    import TransferEconomicForm from '@/components/bank/TransferEconomicForm.vue';
    import { ChevronRight } from 'lucide-vue-next';
    import { Row } from '@tanstack/table-core';
    import type { ViiaAccount } from '@/types';
    import { computed } from 'vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TransferEconomic',
  props: {
    selectedCompanyId: {},
    accountId: {},
    selectedRows: {},
    dbAccount: {}
  },
  setup(__props: any) {

    const props = __props;

    const transactions = computed(() => {
        return props.selectedRows.map((row) => row.id);
    });

    const form = useForm({
        cashbook_id: null,
        cashBookType: 5, // Finance Voucher
        contra_account_nr: null,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.transactions.transfer-economic', _ctx.selectedCompanyId),
    "query-key": [_unref(QueryKey).TRANSACTIONS, _ctx.selectedCompanyId, _ctx.accountId],
    title: "viia.transactions.transfer-economic",
    "submit-text": "viia.transactions.transfer-economic",
    transform: 
            (data) => ({
                ...data,
                transactions: transactions.value,
                accountId: _ctx.accountId,
            })
        
  }, {
    trigger: _withCtx(() => [
      _createVNode(_unref(Button), {
        variant: "ghost",
        width: "narrow",
        class: "self-start",
        size: "xs",
        disabled: !_ctx.selectedRows.length
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('viia.transactions.transfer-economic')) + " (" + _toDisplayString(_ctx.selectedRows.length) + ") ", 1),
          _createVNode(_unref(ChevronRight), { class: "text-accent" })
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(TransferEconomicForm, {
        form: _unref(form),
        "db-account": _ctx.dbAccount
      }, null, 8, ["form", "db-account"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key", "transform"]))
}
}

})